import Axios from "Services/Auth/AxiosInterceptors";

export const CreateAdmin = async (payload) => {
  return await Axios.post(`/admin/admin/admin-signsup-admin`, payload);
};
